import RatingAgencies from './RatingAgencies';

export default RatingAgencies;
